/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authTeamsGet } from "../../funcs/authTeamsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetTeamRequest$inboundSchema,
};

export const tool$authTeamsGet: ToolDefinition<typeof args> = {
  name: "auth-teams-get",
  description: `Get a team`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authTeamsGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
